class LanguageSwitcher extends HTMLElement {
  constructor() {
    super();
    this.#init();
  }

  #init() {
    this.#setCurrentLanguage();
    this.#setActiveOption();
  }

  #setCurrentLanguage() {
    const currentLang = this.#detectLanguage();
    const flagElement = this.querySelector('.language-switcher__flag');
    const codeElement = this.querySelector('.language-switcher__code');

    if (!flagElement || !codeElement) return;

    if (currentLang === 'es') {
      flagElement.textContent = '🇪🇸';
      codeElement.textContent = 'ES';
    } else {
      flagElement.textContent = '🇺🇸';
      codeElement.textContent = 'EN';
    }

    // Store current language for potential use by other components
    this.dataset.currentLang = currentLang;
  }

  #setActiveOption() {
    const currentLang = this.#detectLanguage();
    const options = this.querySelectorAll('.language-switcher__option');

    options.forEach(option => {
      const optionLang = option.dataset.lang;
      if (optionLang === currentLang) {
        option.classList.add('language-switcher__option--active');
      } else {
        option.classList.remove('language-switcher__option--active');
      }
    });
  }

  #detectLanguage() {
    const hostname = window.location.hostname;
    return hostname.includes('es.shapewearusa.com') ? 'es' : 'en';
  }
}

customElements.define('language-switcher', LanguageSwitcher);
